import request from '../../axios';

const getStoreViews = async () => {
  const {data}: {data: IStoreView[]} = await request.get(
    '/api/v2/store/store-view',
  );
  return data;
};

export default getStoreViews;
